/**
 * @file message-text.tsx
 * @description Текст сообщения в пузыре (chat-window-design.md §3): ссылки
 * кликабельны, длинное сообщение (больше 1 500 знаков) свёрнуто с кнопкой
 * «Показать полностью». Сворачивается уже разобранный текст — ссылка не
 * обрывается внутри адреса (`clipParts`).
 */

import { Fragment, useMemo, useState } from "react";

import { CHAT_TEXT } from "./chat-texts";
import { LONG_MESSAGE_CHARS, clipParts, splitLinks } from "./message-links";

export function MessageText({ body, linkClass }: { body: string; linkClass: string }) {
  const [full, setFull] = useState(false);
  const parts = useMemo(() => splitLinks(body), [body]);
  const clip = useMemo(() => clipParts(parts, LONG_MESSAGE_CHARS), [parts]);
  const collapsed = clip.clipped && !full;
  const shown = collapsed ? clip.parts : parts;
  return (
    <>
      <span className="whitespace-pre-wrap break-words">
        {shown.map((part, i) =>
          part.href ? (
            <a key={i} href={part.href} target="_blank" rel="noreferrer noopener" className={linkClass}>
              {part.text}
            </a>
          ) : (
            <Fragment key={i}>{part.text}</Fragment>
          ),
        )}
        {collapsed ? "…" : null}
      </span>
      {collapsed ? (
        <button type="button" onClick={() => setFull(true)} className={`mt-1 block text-sm font-medium ${linkClass}`}>
          {CHAT_TEXT.showFull}
        </button>
      ) : null}
    </>
  );
}
